module.exports = __webpack_public_path__ + "img/1.2.138f8db2.png";